module.exports = __webpack_public_path__ + "img/sh.abef6ce9.svg";